import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61931ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-col items-center max-w-[300px] mt-10"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-medium text-center mb-6" }, " Connect your wallet to view your transaction history ", -1))
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center max-w-[300px] mt-10"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-medium text-center mb-6" }, " No transaction history for this wallet address ", -1))
const _hoisted_5 = {
  key: 2,
  class: "history"
}
const _hoisted_6 = { class: "flex flex-row items-center p-2 mb-3 justify-between" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex flex-row justify-between items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_connect_wallet = _resolveComponent("connect-wallet")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_transaction = _resolveComponent("transaction")!
  const _component_from_to = _resolveComponent("from-to")!
  const _component_amount = _resolveComponent("amount")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_paginate = _resolveComponent("paginate")!

  return (!_ctx.address && !_ctx.addrParam)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_connect_wallet, { primary: "" })
      ]))
    : (_ctx.history && !_ctx.history.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_connect_wallet, {
            text: "Open Bridge",
            primary: "",
            onConnected: _ctx.toBridge
          }, null, 8, ["onConnected"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_n_text, { class: "uppercase text-lg font-semibold" }, {
              default: _withCtx(() => [
                _createTextVNode(" Transaction History ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_text, { class: "opacity-70 text-lg uppercase" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.txCount) + " total", 1)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (tx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tx,
              onClick: ($event: any) => (_ctx.toTx(tx)),
              class: "cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_transaction, { tx: tx }, null, 8, ["tx"]),
                _createVNode(_component_from_to, { tx: tx }, null, 8, ["tx"]),
                _createVNode(_component_amount, { tx: tx }, null, 8, ["tx"])
              ]),
              _createVNode(_component_n_divider)
            ], 8, _hoisted_7))
          }), 128)),
          _createVNode(_component_paginate, {
            size: 7,
            pollInterval: 60000,
            pageCount: _ctx.txCount / _ctx.size,
            onFetch: _ctx.getHistory
          }, null, 8, ["pageCount", "onFetch"])
        ]))
}